import React from 'react'
import styles from './PageTitle.module.css'

const PageTitle = ({ children }) => {
  return <h2 className={styles.container}>{children}</h2>
}

export default PageTitle
